import { Text, View } from '@react-pdf/renderer';
import { cellPdf, stylesPdf } from '../../../pdfs';

// const fieldEmpty = (c, t) => {
//   const list = []
//   const percent = (c / t) * 100;
//   for (let index = 0; index < c; index++) {
//     list.push(cellPdf({
//       width: `${percent}%`,
//       stylesText: stylesPdf.text,
//       stylesCell: {
//         borderRightWidth: (index + 1) === c ? 1 : 0,
//       },
//     }))
//   }
//   return list;
// }

const row = (el, i) => {
  const estudiante = `${el.matricula.estudiante.usuario.perfil.pnombre} ${
    el.matricula.estudiante.usuario.perfil.snombre ?? ''
  } ${el.matricula.estudiante.usuario.perfil.papellido} ${
    el.matricula.estudiante.usuario.perfil.sapellido ?? ''
  }`;

  const representante = `${el.familiar.perfil.pnombre} ${el.familiar.perfil.papellido}`;

  return (
    <View style={stylesPdf.row}>
      {cellPdf({
        value: i,
        width: '5%',
      })}
      {cellPdf({
        value: `${el.codigo}`,
        width: '10%',
      })}
      {cellPdf({
        value: `${el.total}`,
        width: '7%',
      })}
      {cellPdf({
        value: `${el.matricula.estudiante.usuario.perfil.tipoDni}-${el.matricula.estudiante.usuario.perfil.dni}`,
        width: '15%',
      })}
      {cellPdf({
        value: `${representante}`,
        width: '50%',
        fontSize: estudiante.length > 50 ? 7 : estudiante.length > 35 ? 8 : 9,
        left: true,
      })}
      {cellPdf({
        value: el.estatus.nombre,
        width: '17%',
        stylesCell: {
          borderRightWidth: 1,
        },
      })}
      {/* {cellPdf({
      width: '12%',
      fontSize: name.length > 50 ? 7 : name.length > 35 ? 8 : 9,
      stylesCell: {
        borderRightWidth: 1,
      },
    })} */}
      {/* {fieldEmpty(4, 40)} */}
    </View>
  );
};

const header = (
  <View style={stylesPdf.row}>
    {cellPdf({
      value: 'Nro',
      width: '5%',
      bold: true,
      color: '#D6D6D6',
    })}
    {cellPdf({
      value: 'Código',
      width: '10%',
      bold: true,
      color: '#D6D6D6',
    })}
    {cellPdf({
      value: 'Total',
      width: '7%',
      bold: true,
      color: '#D6D6D6',
    })}
    {cellPdf({
      value: 'Identificación',
      width: '15%',
      bold: true,
      color: '#D6D6D6',
    })}
    {cellPdf({
      value: 'Representante',
      width: '50%',
      bold: true,
      color: '#D6D6D6',
    })}
    {cellPdf({
      value: 'Estatus',
      width: '17%',
      bold: true,
      color: '#D6D6D6',
      stylesCell: {
        borderRightWidth: 1,
      },
    })}
    {/* {cellPdf({
    width: '12%',
    bold: true,
    color: '#D6D6D6'
  })} */}
  </View>
);

const TablaRecibosPdf = ({ data }) => {
  return (
    <View style={stylesPdf.section}>
      <View style={{ borderBottom: 1, paddingBottom: 5 }}>
        <Text style={stylesPdf.title}>LISTA DE RECIBOS</Text>
      </View>
      {header}
      {data.map((el, i) => row(el, i + 1))}
    </View>
  );
};

export default TablaRecibosPdf;
